import { Dropdown, type DropdownProps, type MenuProps } from 'antd'
import { useAccess } from '@/hooks/use-access.ts'
import { canPerformAction } from '@/utils/action-access.ts'

export function AuthorizedDropdown({ resource, menu, ...props }: DropdownProps & { resource: string }) {
  const { session } = useAccess()
  const items: MenuProps['items'] = (menu?.items ?? []).filter((item) => {
    if (!item) return false
    if (item.type === 'divider') return true
    return canPerformAction(session, resource, String(item.key))
  })
  if (!items.some((item) => item && item.type !== 'divider')) return null
  return <Dropdown {...props} menu={{ ...menu, items }} />
}
